<template>
    <p class="loan-repayment-amount">
        <span>
            <span :class="['main-text', 'small-main-text']">
                {{ fees_display }}
            </span>

            <span class="small-text d-flex align-self-start"
                  v-html="loanTermLabel"
            ></span>
        </span>
    </p>
</template>

<script>
import { formatCurrency } from '@js/utilities/number.js'

export default {
    props: {
        isStatic: {
            type: Boolean,
            default: false,
        },
        showFeesLabel: {
            type: Boolean,
            default: false,
        },
        showTermLabel: {
            type: Boolean,
            default: false,
        },
    },
    inject: ['offer'],
    computed: {
        loanTermLabel: function () {
            switch (true) {
                case this.showTermLabel:
                    return this.$t('results.locFees')
                case this.isStatic:
                    return this.$t('results.loanTermLabel')
                default:
                    return this.$t('results.loanTerm', { termDisplay: this.offer.term_display })
            }
        },
        fees_display: function () {
            if(this.showFeesLabel){
                return this.$t('results.noFees')
            }

            if(this.isStatic){
                return this.$t('results.monthlyFees')
            }

            return this.formatCurrency(this.offer.fees_display)
        },
    },
    methods: {
        formatCurrency: formatCurrency,
    },
}
</script>
